import React from 'react'
import { UserInfo } from '../../misc/domain/user'

/**
 * Contact details + emergency contact for a user, rendered as compact label/value rows.
 * Shown to interpreters so they can act in an emergency. Reused by the online-users popover and the
 * recent-calls list — the latter reads the user's info off the call/room (which carries it even
 * after the user has dropped off the online list).
 */
export const UserContactInfo: React.FC<{ info?: UserInfo }> = ({ info }) => {
  const person = info?.person
  const emergency = info?.emergency
  const emergencyName = [emergency?.first_name, emergency?.last_name].filter(Boolean).join(' ')

  const row = (label: string, value?: string) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, padding: '3px 12px', fontSize: 13 }}>
      <span style={{ color: '#9B9B9B', whiteSpace: 'nowrap' }}>{label}</span>
      <span style={{ color: '#333', textAlign: 'right', fontWeight: 600, wordBreak: 'break-word' }}>{value || '—'}</span>
    </div>
  )

  return (
    <div style={{ borderTop: '1px solid #F2F2F5', paddingTop: 6, paddingBottom: 6 }}>
      {row('Τηλέφωνο', person?.phone)}
      {row('Διεύθυνση', person?.address)}
      {person?.kepa_id ? row('ΚΕΠΑ', person?.kepa_id) : null}
      <div style={{
        padding: '8px 12px 2px',
        marginTop: 4,
        borderTop: '1px solid #F2F2F5',
        fontSize: 11,
        fontWeight: 800,
        letterSpacing: 0.5,
        textTransform: 'uppercase',
        color: '#E24B4B',
      }}>Επείγουσα επαφή</div>
      {row('Όνομα', emergencyName)}
      {row('Τηλέφωνο', emergency?.phone)}
    </div>
  )
}

export default UserContactInfo
